/**
 * Lifecycle event types.
 */
export var ComponentEventType;
(function (ComponentEventType) {
    ComponentEventType["BeforeCreate"] = "beforeCreate";
    ComponentEventType["Created"] = "created";
    ComponentEventType["BeforeMount"] = "beforeMount";
    ComponentEventType["Mounted"] = "mounted";
    ComponentEventType["BeforeUpdate"] = "beforeUpdate";
    ComponentEventType["Updated"] = "updated";
    ComponentEventType["BeforeDestroy"] = "beforeDestroy";
    ComponentEventType["Destroyed"] = "destroyed";
    ComponentEventType["Error"] = "error";
    ComponentEventType["Data"] = "data";
})(ComponentEventType || (ComponentEventType = {}));
/**
 * Events triggered by the components
 */
var ComponentEvent = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param id Component unique identifier.
     * @param type The type of event.
     * @param el The component root element.
     * @param parentEl The parent element of the component.
     * @param error The error data in case this is an error event.
     */
    function ComponentEvent(id, type, el, parentEl, error) {
        this.id = id;
        this.type = type;
        this.el = el;
        this.parentEl = parentEl;
        this.error = error;
        this.timestamp = new Date();
    }
    return ComponentEvent;
}());
export { ComponentEvent };
//# sourceMappingURL=componentEvent.js.map